function getFirstValue(item, keys, fallback = "") {
  for (const key of keys) {
    if (item?.[key] !== undefined && item?.[key] !== null && String(item[key]).trim() !== "") {
      return item[key];
    }
  }

  return fallback;
}

export function getMonthTimelineValue(item) {
  return getFirstValue(item, ["mes_ano", "mesAno", "competencia", "mes"], "");
}

export function monthYearOrder(value) {
  const [month, year] = String(value || "").split("/").map((part) => Number(part));

  if (!Number.isInteger(month) || !Number.isInteger(year) || month < 1 || month > 12) {
    return Number.MAX_SAFE_INTEGER;
  }

  return year * 100 + month;
}

export function sortByMonthTimeline(items = []) {
  return [...items]
    .map((item, index) => ({ item, index }))
    .sort((left, right) => {
      const orderDiff = monthYearOrder(getMonthTimelineValue(left.item)) - monthYearOrder(getMonthTimelineValue(right.item));
      return orderDiff || left.index - right.index;
    })
    .map(({ item }) => item);
}
